import Swiper                 from 'swiper';
import { Navigation, Mousewheel  } from 'swiper/modules';

const sliders = () => {
    const slidersPost = document.querySelectorAll('[data-slider="default"]');
    slidersPost.forEach((el) => {
        const sliderNav = el.dataset.nav;
        const sliders   = new Swiper(el, {
            modules       : [Navigation, Mousewheel ],
            slidesPerView : 'auto',
            spaceBetween  : 24,
            loop          : false,
            speed         : 500,
            freeMode: true,
            freeModeMomentum: false,
            mousewheel: {
                forceToAxis: true,
                sensitivity: 1,
                releaseOnEdges: true,
            },
            navigation    : {
                prevEl : `[data-prev="${sliderNav}"]`,
                nextEl : `[data-next="${sliderNav}"]`
            }

        });
    });
};
export default sliders;
